// extracted by mini-css-extract-plugin
export default {"rotation-wizard-edit-container__message":"rotation-wizard-edit-container__message--jI2jc","rotationWizardEditContainerMessage":"rotation-wizard-edit-container__message--jI2jc"};